import React from 'react';
import { Page } from "Components";
import { SyncLoader } from "react-spinners";

const LoadingPage = ({message = ''}) => {
    return <Page className={`flex flex-col h-full items-center justify-center`}>
        <h1 className={`text-3xl md:text-5xl flex-none color1-text mb-10 animate-bounce`}>{message}</h1>
        <SyncLoader
            color="white"
            margin={10}
            size={20}
            speedMultiplier={0.6}
            aria-label={message}
        />
    </Page>
};

export default LoadingPage;
